export const typeOfDocumentsLabels = {
	checkbox: "checkbox",
	date: "date",
	text: "text",
	shortText: "shortText",
	select: "select",
	signature: "signature",
	radio: "radio",
	number: "number",
	initials: "initials",
};
